import { render, staticRenderFns } from "./HuanbeiVisitor.vue?vue&type=template&id=cf2bfc02&scoped=true&"
import script from "./HuanbeiVisitor.vue?vue&type=script&lang=js&"
export * from "./HuanbeiVisitor.vue?vue&type=script&lang=js&"
import style0 from "./HuanbeiVisitor.vue?vue&type=style&index=0&id=cf2bfc02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2bfc02",
  null
  
)

export default component.exports